import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
interface Props {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

export const ConfirmationModal: React.FC<Props> = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Delete',
  cancelText = 'Cancel',
}) => {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[1000] p-4">
      <div className="bg-white rounded-[8px] shadow-2xl max-w-[500px] w-full p-3 relative" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-xs font-bold text-slate-800 mb-0">{title}</h3>
          <button className="p-1.5 text-slate-600 hover:text-slate-800 hover:bg-slate-100 rounded-full transition-colors" onClick={onCancel}>
            <CloseIcon sx={{ fontSize: 18 }} />
          </button>
        </div>
        <div className="mb-3">
          <p className="text-xs text-slate-600">{message}</p>
        </div>
        <div className="flex justify-end gap-2">
          <button 
            className="px-4 py-2.5 bg-slate-100 text-slate-700 rounded-lg font-medium hover:bg-slate-200 transition-colors text-xs"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button 
            className="px-4 py-2.5 bg-red-500 text-white rounded-lg font-medium hover:bg-red-600 transition-colors text-xs"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
